import React, { useState, useEffect } from 'react';
import { useAppContext } from '../context/AppContext';
import { SUGGESTIONS, EXAMPLE_PROMPTS } from '../constants/suggestions';

const WelcomeScreen = () => {
  const { theme } = useAppContext();
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    setTimeout(() => setAnimate(true), 100);
  }, []);

  return (
    <div className="text-center h-full flex flex-col justify-center items-center pt-20">
      <h1 className={`text-4xl font-bold ${theme === 'dark' ? 'text-white' : 'text-gray-900'} mb-4`}>
        Hi, there
      </h1>
      <p className={`${theme === 'dark' ? 'text-gray-300' : 'text-gray-600'} mb-8`}>
        Tell us what you need, and we'll handle the rest.
      </p>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 w-full max-w-4xl mb-8">
        {SUGGESTIONS.map((s, i) => {
          const IconComponent = s.icon;
          return (
            <div 
              key={i} 
              className={`${theme === 'dark' ? 'bg-black border-gray-600' : 'bg-white border-gray-300'} p-4 rounded-lg border   transform `}
              style={{ transitionDelay: `${i * 100}ms` }}
            >
              <div className="flex items-center gap-3 mb-2">
                <IconComponent size={24} className={s.iconColor} />
                <h3 className={`font-bold ${theme === 'dark' ? 'text-gray-100' : 'text-gray-900'}`}>
                  {s.title}
                </h3>
              </div>
              <p className={`text-sm ${theme === 'dark' ? 'text-gray-300' : 'text-gray-600'}`}>
                {s.prompt}
              </p>
            </div>
          );
        })}
      </div>
      
      <div className="w-full max-w-4xl">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-2 mb-4">
          {EXAMPLE_PROMPTS.map((prompt, i) => (
            <div 
              key={i}
              className={`${theme === 'dark' ? 'bg-black border-gray-600' : 'bg-white border-gray-300'} p-3 rounded-lg border flex items-center gap-2`}
            >
              <span className={`${theme === 'dark' ? 'text-gray-500' : 'text-gray-400'}`}>
                {prompt.icon}
              </span>
              <p className={`text-sm ${theme === 'dark' ? 'text-gray-300' : 'text-gray-700'}`}>
                {prompt.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WelcomeScreen;